import { Pipe, PipeTransform } from '@angular/core';
import {CompetitorStageDetail, FINISH_CONTROL_POINT_TYPE, MeasurementPrecisionTypes} from "@model";
import {ResultsTimePipe} from "./time-milliseconds.pipe";

@Pipe({
  name: 'finishAndLastCpDiff'
})
export class FinishAndLastCpDiffPipe implements PipeTransform {
  constructor(private resultsTimePipe: ResultsTimePipe) {}

  transform(SGS?: { [key: string]: CompetitorStageDetail }, measurementPrecisionType?: MeasurementPrecisionTypes | undefined): string {
    if (SGS === undefined || SGS === null) {
      return '-';
    }
    const items = Object.values(SGS);
    const sgsFinishItem = items.find((item) => item.tp === FINISH_CONTROL_POINT_TYPE);
    return this.resultsTimePipe.transform(sgsFinishItem?.nt_tm, measurementPrecisionType) || '-';
  }
}
